import React, { Component } from 'react';
import {
	Card, CardHeader, CardBody, FormGroup, FormText, Label, Modal, ModalBody, Button, Progress, Row, Col
} from 'reactstrap';
import { CNav, CNavItem, CNavLink, CTabContent } from '@coreui/react';

import { initContext, setContext } from 'core/ducks/context';
import * as roles from 'core/model/roles';
import { Content } from 'flows/views/components';
import { getData } from 'core/ducks/update';
import { uploadData, cancelUpload } from 'core/ducks/upload';
import { buildPath } from 'core/model/lib/urlTools';
import { ErrorPage } from 'core/views/pages';
import { DynamicRoutes } from 'app/model/routes';
import { ThreadModal } from 'app-messages';
import withApp from './app';

import T from 'modules/i18n';

class ApplyWrapper extends Component {
  render() {
		return <Apply {...this.props} key={`apply_${this.props.match.params.round}_${this.props.match.params.application}`}/>
  }
}

class Apply extends Component {

  constructor(props) {
		super(props);
    this.state = {
      round: {},
      node: {},
      history: [],
      tree: [],
      values: {},
      content: [],
      messages: 0,
      readOnly: true,
      ready: false,
      httpStatus: 200,
			current: '',
      registrationNumber: null,
      modifies: null,
      status: null,
      showProgress: false,
      isMessageThreadOpen: false,
      loadingWFS: false,
      spatialContentNotFound: false,
      prevValues: {},
      hasBeenEditable: false,
      stationId: null,
      listOfStationId: null,	
    }
  }

  componentDidMount() {
		const searchParams = new URLSearchParams(window.location.search);
		const stationId = searchParams.get('stationId');
		const listOfStationId = searchParams.get('list_of_station_id');

		// Set stationId and listOfStationId in state
		this.setState({ 
			stationId,
			listOfStationId: listOfStationId ? JSON.parse(decodeURIComponent(listOfStationId)) : null
		});
		this.props.dispatch(initContext({round: {...this.state.round}}));
		this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.round !== this.props.match.params.round) {
			this.fetchData();
    }
    if (prevProps.match.params.step !== this.props.match.params.step) {
			this.fetchData();
    }
    if (prevState.node !== this.state.node) {
			if (this.state.node.type === 'form' && (this.state.node.content.startsWith('geoserver_details') || this.state.node.content.startsWith('mitroo_cheiristi'))) {
				const content = this.state.content.map(field => ({...field, final: true}));
				this.setState({content});
				if ((this.state.status === 'progressing' || this.state.readOnly) && this.state.modifies)
					this.handleWFS({registry: this.state.modifies, status: '1'});
			}
			if (this.state.node.type === 'form' && this.state.node.content.startsWith('apetek0302')) {
					this.handleRegistrySahe();
			}
		}
		if (prevProps.messages.unread.length < this.props.messages.unread.length ) {
			const prev = prevProps.messages.unread.map(m => m.uuid);
      const newMessages = this.props.messages.unread
				.filter(m => !prev.includes(m.uuid))
				.filter(m => m.application === this.props.match.params.application).length;
			if (newMessages > 0)
				this.setState({messages: this.state.messages + newMessages});
    }
		if (prevState.round !== this.state.round)
			this.props.dispatch(setContext({round: {...this.state.round}}));
  }

	fetchData = () => {
		const url = this.createUrl();
		this.props.dispatch( getData(url) )
			.then(data => this.setState({
				...data,
				stationId: data.station_id || this.state.stationId,
				listOfStationId: data.list_of_station_id || this.state.listOfStationId,
				ready: true,
				prevValues: {},
				spatialContentNotFound: false,
				loadingWFS: false,
				hasBeenEditable: false,
			}, () => {
				// Keep global context in sync so sidebars can react
				this.props.dispatch(setContext({
					round: { ...this.state.round },
					applicationStatus: this.state.status,
				}));
			}))
			.catch(httpStatus => this.setState({httpStatus}));
	}

  handleSubmit = (data) => {
		if (this.state.current && this.state.node.mname !== this.state.current)
			data.append('_method', 'put');
		const url = this.createUrl();
		this.setState({showProgress: true}, () => {
			this.props.dispatch( uploadData(url, data) ).then(response => {
				this.setState({showProgress: false});
				const { application, current_node } = response;
				// Determine which route to use based on current path
				const isAdminRoute = this.props.location.pathname.includes('/admin/apply/');
				const routeToUse = isAdminRoute ? DynamicRoutes.AdminApply : DynamicRoutes.Apply;
				this.props.history.push(
					buildPath(routeToUse, [this.state.round.mname, application, current_node])
				);
        })
			.catch(error => {
				this.setState({showProgress: false});
				console.warn(error);
			});
		});
  }

  createUrl = () => {
		let { round, step, application } = this.props.match.params;

		if (!step)
			step = this.state.node.mname;
		const url = ['flows/apply'];
		url.push(`round/${round}`);
		if (application)
			url.push(`application/${application}`);
		if (step)
			url.push(`node/${step}`);

		if (!application && this.state.stationId) {
			url.push(`stationId/${this.state.stationId}`);
		}

		if (!application && this.state.listOfStationId) {
			url.push(`listOfStationId/${encodeURIComponent(JSON.stringify(this.state.listOfStationId))}`);
		}

		const finalUrl = url.join('/');
		console.log("=== CREATED URL ===", finalUrl);
		console.log("Current state:", {
			stationId: this.state.stationId,
			listOfStationId: this.state.listOfStationId,
			application: application
		});

		return finalUrl;
  }

	handleWFS = ({application=null, registry=null, status='1', mitroo=false}) => {
		this.setState({loadingWFS: true});
		const url = ['app', 'wfs'];
		if (application)
			url.push(`application/${application}`);
		if (registry)
			url.push(`registry/${registry}`);
		if (mitroo)
			url.push(`mitroo/${mitroo}`);
		url.push(`status/${status}`);
		this.props.dispatch(getData(url.join('/')))
			.then(values => {
        if (this.state.current === this.props.match.params.step) {
					const content = this.state.content.map(field => ({...field, final: true}));
					this.setState({values, content, spatialContentNotFound: false});
        } else {
					this.setState({prevValues: values, spatialContentNotFound: false});
        }
      })
			.catch(httpCode => {
				console.warn(httpCode);
        if (httpCode === 404) {
					this.setState({spatialContentNotFound: true});
					this.makeFormEditable();
        }
      })
			.finally(() => this.setState({loadingWFS: false}));
	}

	handleRegistrySahe = () => {
		let { application } = this.props.match.params;
		const url = ['flows', 'applications-form-field-sahe']
		if (application)
			url.push(`application/${application}`);
		this.props.dispatch(getData(url.join('/')))
			.then(values => {
				if (this.state.current === this.props.match.params.step) {
					const content = this.state.content.map(field => ({...field, final: false}));
					this.setState({values, content, registryContentNotFound: false});
				} else {
					this.setState({prevValues: values, registryContentNotFound: false});
				}
			})
			.catch(httpCode => {
				console.warn(httpCode);
				if (httpCode === 404) {
					this.setState({registryContentNotFound: true});
					this.makeFormEditable();
				}
			})
	}

  makeFormEditable = () => {
		const content = this.state.content.map(field => ({...field, final: false}));
		this.setState({content, hasBeenEditable: true});
  }

  toggleMessageThread = () => {
    this.setState({
      isMessageThreadOpen: !this.state.isMessageThreadOpen,
		});
  }

  render() {
		const { progress } = this.props.upload;
		const { application } = this.props.match.params;
		const { round, httpStatus } = this.state;
		if (httpStatus !== 200)
			return (<ErrorPage status={httpStatus}/>);

    // console.log('Local Storage Data:', JSON.stringify(localStorage));

    return (
      <Card className="m-2 p-2 w-md-75">
        <CardHeader tag="h4">{round.label}</CardHeader>
        <CardBody>
					{ (this.props.role === roles.AUTHORIZED && this.state.messages > 0) &&
            <Row>
              <Col className="d-flex justify-content-end py-2">
                <Button outline color="info" onClick={this.toggleMessageThread}>
									<i className="icon-envelope-letter"/>{` ${this.state.messages}`}
                </Button>
              </Col>
            </Row>
					}
          <CNav variant="pills" layout="justified" role="tablist">
						{ this.state.tree.map(step => (
              <CNavItem key={`nav-item-${step.node}`}>
                <CNavLink
                  href="#"
                  active={step.active}
                  disabled={step.disabled}
									onClick={() => this.props.history.push(buildPath(this.props.role !== roles.AUTHORIZED ? DynamicRoutes.AdminApply : DynamicRoutes.Apply, [round.mname, application, step.node]))}
                >
                  {step.label}
                </CNavLink>
              </CNavItem>
            ))}
          </CNav>
					<div className="mt-2"><div className="mx-auto border-bottom w-75"/></div>
          <CTabContent>
						{ (this.state.status !== 'progressing' && !this.state.readOnly && this.state.node.type === 'form' && this.state.node.content.startsWith('geoserver_details')) && (
                <Row>
                  <Col className="d-flex justify-content-end">
									<Button outline color="warning" className="my-2 mx-5" onClick={() => this.handleWFS({application, status: '7'})}>WFS</Button>
								</Col>
							</Row>
						)}
						{ (this.state.status !== 'progressing' && !this.state.readOnly && this.state.node.type === 'form' && this.state.node.content.startsWith('apetek0302')) && (
							<Row>
								<Col className="d-flex justify-content-end">
									<Button outline color="warning" className="my-2 mx-5" onClick={() => this.handleWFS({application, status: '7'})}>WFS</Button>
								</Col>
							</Row>
						)}
						{ (this.state.status !== 'progressing' && !this.state.readOnly && this.state.node.type === 'form' && this.state.node.content.startsWith('mitroo_cheiristi')) && (
                <Row>
                  <Col className="d-flex justify-content-end">
									<Button outline color="warning" className="my-2 mx-5" onClick={() => this.handleWFS({application, mitroo: true})}>Ανάκτηση στοιχείων από Μητρώο</Button>
                  </Col>
                </Row>
              )}
						{ this.state.loadingWFS && (
              <FormGroup className="text-center m-2 font-weight-bold">
                <FormText color="muted">
									<i className="fa fa-spinner fa-spin fa-2x mr-2"/><span>Φόρτωση δεδομένων</	span>
                </FormText>
              </FormGroup>
            )}
						{ this.state.spatialContentNotFound && (
              <FormGroup className="text-center m-2 font-weight-bold">
								{ this.state.readOnly ? (
									<FormText color="info">
										Δεν είχαν καταχωριστεί δεδομένα.
									</FormText>
                ) : (
                  <FormText color="info">
                    Δεν βρέθηκαν δεδομένα για την αίτηση σας. Παρακαλούμε προχωρήστε στην συμπλήρωση της φόρμας.
                  </FormText>
                )}
              </FormGroup>
            )}
			<Row className="mb-3" style={{ 
				marginLeft: "-30px",
				width: "150%",
				position: "relative",
				overflow: "visible"
			}}>
				<Col md={12} className="d-flex" style={{ paddingLeft: "0", paddingRight: "0" }}>
					{this.state.stationId && (
					<div className="d-flex align-items-center" style={{ width: "40%" }}>
						<Label
						className="font-weight-bold mb-0"
						style={{
							letterSpacing: "0.5px",
							width: "120px",
							textAlign: "right",
							marginRight: "5px",
						}}>
						<T>station_id</T>:
						</Label>
						<div
						className="form-control-plaintext d-flex align-items-center justify-content-center"
						style={{
							backgroundColor: "#f8f9fa",
							height: "32px",
							width: "120px",
							borderRadius: "4px",
							borderBottom: "1px solid #ced4da",
						}}
						>
						{this.state.stationId}
						</div>
					</div>
					)}
					{this.state.registrationNumber && (
					<div className="d-flex align-items-center" style={{ 
						width: "60%", 
						paddingLeft: this.state.stationId ? "80px" : "0px" 
					}}>
						<Label
						className="font-weight-bold mb-0"
						style={{
							letterSpacing: "0.5px",
							width: "160px",
							textAlign: "right",
							marginRight: "5px",
						}}
						>
						<T>registration_number</T>:
						</Label>
						<div
						className="form-control-plaintext d-flex align-items-center justify-content-center"
						style={{
							backgroundColor: "#f8f9fa",
							height: "32px",
							width: "120px",
							borderRadius: "4px",
							borderBottom: "1px solid #ced4da",
						}}
						>
						{this.state.registrationNumber}
						</div>
					</div>
					)}
				</Col>
			</Row>
            <Content
              node={this.state.node}
              content={this.state.content}
              onSubmit={this.handleSubmit}
              disabled={this.state.readOnly || this.state.loadingWFS}
              values={this.state.values}
              makeEditable={this.makeFormEditable}
							isEditButtonEnabled={(this.props.role === roles.AUTHORIZED && !this.state.readOnly && !this.state.hasBeenEditable && this.state.node.type === 'form' && (this.state.node.content.startsWith('geoserver_details') || this.state.node.content.startsWith('mitroo_cheiristi')))}
              prevValues={this.state.prevValues}
            />
            <Modal isOpen={this.state.showProgress} className="modal-md">
              <ModalBody>
                <p>Παρακαλούμε περιμένετε τη μεταφόρτωση των δεδομένων...</p>
                <Progress animated value={progress} />
                <div className="text-right p-1">
									<Button type="button" onClick={() => {
										cancelUpload('Operation canceled by the user.');
										this.setState({showProgress: false});
									}}>
                    Ακύρωση
                  </Button>
                </div>
              </ModalBody>
            </Modal>
          </CTabContent>
        </CardBody>
				{ (application && this.props.role === roles.AUTHORIZED) &&
					<ThreadModal isOpen={this.state.isMessageThreadOpen} toggle={this.toggleMessageThread} application={application}/>
				}
      </Card>
		);
  }
}

export default withApp(ApplyWrapper);
